/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable default-param-last                           */
/* ***************************************************************** */
import { ScopedType } from './scoped-type';
import { get } from '../../lib/api';

const Type = ScopedType('ENVIRONMENT');
const LOADED = Type('LOADED');

export const selectors = {
  farmgateUrl: (state) => state.environment.farmgateUrl,
};

export const reducers = {
  environment: environmentReducer,
};

export const actions = {
  loadEnvironment,
};

function loadEnvironment() {
  return async (dispatch) => {
    dispatch({ type: LOADED, payload: await get('/environment') });
  };
}

function environmentReducer(state = {}, { type, payload }) {
  switch (type) {
    case LOADED:
      return { ...payload };
    default:
      return state;
  }
}
